import { combineEpics } from 'redux-observable';
import DataSourceDuplicateEpic from './DataSourceDuplicateEpic';
import DataSourceFlightFormatsEpic from './DataSourceFlightFormatsEpic';
import DataSourceCreateEpic from './DataSourceCreateEpic';
import DataSourceUpdateEpic from './DataSourceUpdateEpic';
import ServicePrincialListEpic from './ServicePrincipalListEpic';
import ManagedIdentityListEpic from './ManagedIdentityList';
export const rootEpic = combineEpics(DataSourceCreateEpic, DataSourceDuplicateEpic, DataSourceFlightFormatsEpic, DataSourceUpdateEpic, ServicePrincialListEpic, ManagedIdentityListEpic);
export default rootEpic;

//# sourceMappingURL=epics.js.map
